import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class RestService {
  constructor(private _http: HttpClient) {}

  login(userinfo: any) {
    userinfo["_type"] = "login";
    return this._http.post(environment.url, userinfo);
  }

  getPilots() {
    let info = { _type: "get_pilots", _token: localStorage.getItem("token") };
    return this._http.post(environment.url, info);
  }

  addPilot(info: any) {
    info["_type"] = "addpilot";
    info["_token"] = localStorage.getItem("token");
    return this._http.post(environment.url, info);
  }

  updatePilot(pilot_id, info: any) {
    console.log(pilot_id, info);
    info["id"] = pilot_id;
    info["_type"] = "updatepilot";
    info["_token"] = localStorage.getItem("token");
    return this._http.post(environment.url, info);
  }
  deletePilot(info: any) {
    info["_type"] = "deletepilot";
    info["_token"] = localStorage.getItem("token");
    return this._http.post(environment.url, info);
  }
}
